<template>
  <transition name="fade">
    <div v-if="visible" class="loading-overlay">
      <div class="loading-content">
        <BpCustomColorLogo width="120" height="60" />
      </div>
    </div>
  </transition>
</template>

<script>
import BpCustomColorLogo from '../../assets/icones/BpCustomColorLogo.vue';

export default {
  name: 'Loading',
  components: { BpCustomColorLogo },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    console.log('visible', this.visible);
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000d37;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: pulse 1.2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.9;
    transform: scale(1.08);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
